export function whichProperty(props){
  var el = document.createElement('fakeelement'),
      len = props.length;
  for(var i = 0; i < props.length; i++){
    var prop = props[i];
    if( el.style[prop] !== undefined ){ return prop; }
  }

  return false; // explicit for ie9-
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/whichProperty.js
// module id = 35
// module chunks = 0